import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const TrueToSizeIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path stroke="currentcolor" strokeLinejoin="round" strokeMiterlimit="10" d="M7.86 15.897V9.299A3.3 3.3 0 0 1 11.16 6H30v6.598h-6.825" />
    <path
      stroke="currentcolor"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M19.876 19.195H11.16a3.299 3.299 0 1 1 0-6.597h12.015v9.896a3.3 3.3 0 0 0-3.299-3.299Z"
    />
    <path
      stroke="currentcolor"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M11.16 19.195H1.333v6.598h18.543a3.3 3.3 0 0 0 3.299-3.298M26.431 6v2.974M22.863 6v2.974M19.294 6v2.974M15.725 6v2.974M12.157 6v2.974M15.608 22.82v2.973M19.177 22.82v2.973M12.04 22.82v2.973M8.47 22.82v2.973M4.902 19.195v6.598"
    />
  </IconV2>
);

export default TrueToSizeIcon;
